import * as React from 'react';

import { ServiceOptionItem } from '../../../../../ServiceSummary/types';
import ServiceSummaryOption from '../../../../../ServiceSummary/components/ServiceSummaryOption';
import { useInsuranceGroups } from '../../lib/useInsuranceGroups';
import { InsuranceProgram } from '../../model/types';

interface Props {
	items: ServiceOptionItem[];
	programs: ReadonlyArray<InsuranceProgram>;
	segmentId: string;
}

const AggregatorInsuranceGroups: React.FC<Props> = ({ items, programs, segmentId }) => {
	const productGroups = useInsuranceGroups(items, segmentId);

	const getProductName = (productItems: ServiceOptionItem[]) => {
		const { id, name } = productItems[0];

		return programs.find(program => program.code === id)?.name || name;
	};

	return (
		<>
			{productGroups.map(({ items: productItems, directions }) =>
				directions.map((direction, directionIndex) => (
					<ServiceSummaryOption
						key={`${productItems[0].id}/${direction.key}`}
						mode="aggregator"
						serviceType="Insurance"
						groupOption={{
							header: directionIndex === 0 ? getProductName(productItems) : undefined,
							subheader: direction.dateLabel,
							items: direction.items
						}}
					/>
				))
			)}
		</>
	);
};

export default AggregatorInsuranceGroups;
